import { combineReducers } from 'redux'
import { SendEmailReducer } from './email'
import messageRecipients from './recipients'
import sendMessageReducer from './message'
import { SendSmsReducer } from './sms'

export default combineReducers({
  email: SendEmailReducer,
  sms: SendSmsReducer,
  recipients: messageRecipients,
  message: sendMessageReducer,
})
